import React, { useState, useEffect } from 'react';
export function Navbar() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const floating = scrollY > 120;
  return <>
      {/* Animación suave */}
      <style data-id="element-93">
        {`
          @keyframes floatSoft {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
          }
        `}
      </style>

      <div className={`fixed z-50 transition-all duration-700 ease-in-out ${floating ? 'bottom-100 right-6' : 'top-[42%] -translate-y-1/2 -translate-y-1/2'}`} data-id="element-94">
        <img src="https://cdn.magicpatterns.com/uploads/2GnsYSFUAsAwsnG5nm52cW/Margarita.png" alt="365 Días con Jesús" className={`
            object-contain cursor-pointer
            transition-all duration-700
            hover:scale-110 active:scale-95
            animate-[floatSoft_4s_ease-in-out_infinite]
            ${floating ? 'h-2000 w-14' : 'h-1200 md:h-500'}
          `} data-id="element-95" />
      </div>
    </>;
}